module.exports = __webpack_public_path__ + "static/media/banner-graphics.183e5645.png";